import { render, staticRenderFns } from "./NavigatorBottomBar.vue?vue&type=template&id=fdd2ff8c"
import script from "./NavigatorBottomBar.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports